import type { JSX } from "react";

import { Stack } from "@mantine/core";

import { Header } from "../call-intro-flow/steps/Header";
import { ConversationalSummary } from "./ConversationalSummary";
import { getFormattedIntent } from "./getFormattedIntent";
import { IVRSummary } from "./IVRSummary";

interface CustomerHandoffProps {
    intent?: string;
    summary?: string;
    device?: string;
    productLink?: string;
    productTitle?: string;

    conversationalSummary?: string;
    customerName?: string;
}

export function CustomerHandoff({
    intent,
    summary,
    device,
    productLink,
    productTitle,
    conversationalSummary,
    customerName,
}: CustomerHandoffProps): JSX.Element {
    const formattedIntent = getFormattedIntent({ device, intent });

    const showConversationalSummary = conversationalSummary && conversationalSummary.length > 0;
    const showIVRSummary = !showConversationalSummary && (formattedIntent || summary);
    return (
        <Stack gap={0}>
            <Stack align="center" pt="md">
                <Header text="What we know" />
            </Stack>
            {showConversationalSummary && (
                <ConversationalSummary
                    intent={formattedIntent}
                    conversationalSummary={conversationalSummary}
                    customerName={customerName}
                />
            )}
            {showIVRSummary && (
                <IVRSummary
                    intent={formattedIntent}
                    summary={summary}
                    productLink={productLink}
                    productTitle={productTitle}
                />
            )}
        </Stack>
    );
}
